/* Apply the current offer code to storefront visitors, without changing catalog prices.
   2026-10-19: one offer only — CRUSH299 (Crush Lifetime $350 -> $299).
   2026-10-21: CRUSH299 is an ORDER discount in Shopify ($51 off $350+, so the free-Wraparound BXGY can stack), which
   means it would also discount the $399 bundle. It is therefore only applied when the Crush Lifetime variant is in the
   cart / in the link, and removed from carts that no longer hold it. CRUSH259 + BUNDLE299 are no longer applied.
   2026-10-27: the Bundle (42706979356747) also gets CRUSH299.
   2026-11-02: free-Wraparound auto-add with the Bundle REMOVED (Wraparound out of stock); see season-codes.js.before-wrap-off-2026-11-02 to bring it back. */
(function () {
  'use strict';
  var expiresAt = Date.parse('2026-11-13T05:00:00Z');
  var offerCodes = ['CRUSH299'];
  var eligibleVariants = ['41822552490059', '42706979356747']; // Crush Lifetime, HUH+Shooting Bundle (2026-10-27: bundle gets CRUSH299 too)
  var cartEligible = false;
  function holdsEligible(text) { return eligibleVariants.some(function (id) { return String(text || '').indexOf(id) >= 0; }); }
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var active = function () { return Date.now() < expiresAt; };
  function mergeCodes(existing) {
    return Array.from(new Set(existing.concat(offerCodes).map(function (code) { return code.toUpperCase(); })));
  }
  function dropCodes(existing) {
    return existing.map(function (code) { return code.toUpperCase(); }).filter(function (code) { return offerCodes.indexOf(code) < 0; });
  }
  function apply() {
    return fetch(root + 'cart.js', {credentials:'same-origin'})
      .then(function (r) { if (!r.ok) throw new Error('Could not read cart'); return r.json(); })
      .then(function (cart) {
        if (!active()) return cart;
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
        cartEligible = (cart.items || []).some(function (item) { return holdsEligible(item.variant_id); });
        var wanted = cartEligible ? mergeCodes(codes) : dropCodes(codes);
        var same = wanted.length === codes.length && wanted.every(function (code) { return codes.map(function (c) { return c.toUpperCase(); }).indexOf(code) >= 0; });
        if (same) return cart;
        return fetch(root + 'cart/update.js', {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({discount:wanted.join(',')})
        }).then(function (r) { if (!r.ok) throw new Error('Could not apply offer'); return r.json(); });
      });
  }
  function checkoutUrl(value) {
    if (!active()) return value;
    var url = new URL(value || '/checkout', location.origin);
    if (!cartEligible && !holdsEligible(url.pathname)) return value;
    var existing = (url.searchParams.get('discount') || '').split(',').filter(Boolean);
    url.searchParams.set('discount', mergeCodes(existing).join(','));
    return url.pathname + url.search + url.hash;
  }
  window.huhSeasonOffer = {apply:apply, checkoutUrl:checkoutUrl};
  // Establish the code even before the shopper adds an eligible product.
  apply().catch(function () {});
  // Theme add-to-cart / drawer quantity changes (Dawn pub/sub): re-check the code after every cart change.
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { apply().catch(function () {}); });
  }
  // Explicit links/forms also carry the codes if the background request is slow.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var url = new URL(link.href, location.origin);
    if (url.origin === location.origin && /\/(?:checkout|cart\/\d)/.test(url.pathname)) link.href = checkoutUrl(link.href);
  }, true);
  document.addEventListener('submit', function (event) {
    if (!active()) return;
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var url = new URL(form.action, location.origin);
    if (url.origin !== location.origin || !/\/(?:cart|checkout)(?:\/|$)/.test(url.pathname)) return;
    var idField = form.querySelector('[name="id"]');
    if (!cartEligible && !holdsEligible(idField && idField.value)) return;
    var field = form.querySelector('input[name="discount"]');
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'discount'; form.appendChild(field); }
    field.value = mergeCodes((field.value || '').split(',').filter(Boolean)).join(',');
  }, true);
})();
